import { useQuery } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import { message } from 'antd';

import { QUERY_KEYS } from '@/utils/query-keys';
import { ErgonomicWorkAnalysisService } from '@/infra/services/ergonomic-work-analysis';

interface GetSelectedCustomReportResultsParams {
	organization_id: string;
	company_id: string;
	id: string;
	limit: number;
	offset: number;
}

const Service = ErgonomicWorkAnalysisService.getInstance();

export const useGetSelectedCustomReportResults = (params: GetSelectedCustomReportResultsParams) => {
	const queryKey = [
		QUERY_KEYS.GET_SELECTED_CUSTOM_REPORT_RESULTS,
		params.organization_id,
		params.company_id,
		params.id,
		params.limit,
		params.offset
	];

	return useQuery({
		queryKey,
		queryFn: async () => Service.getSelectedCustomReportResults(params),
		enabled: !!params.organization_id && !!params.company_id && !!params.id,
		retry: 0,
		refetchOnWindowFocus: false,
		onError: (error: any) => {
			message.error(I18n.get(error.response?.data?.message ?? 'Ops... something happened!'));
		}
	});
};
